import { render, staticRenderFns } from "./MudarInstituicao-adm.vue?vue&type=template&id=5be2cce0&scoped=true&"
import script from "./MudarInstituicao-adm.vue?vue&type=script&lang=js&"
export * from "./MudarInstituicao-adm.vue?vue&type=script&lang=js&"
import style0 from "./MudarInstituicao-adm.vue?vue&type=style&index=0&id=5be2cce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be2cce0",
  null
  
)

export default component.exports